export const labels = {
	information: {
		label: "Label.MobileCreator.PhotoInfo.Information",
		default: "Information",
	},
} as const;
